/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import DialerServiceData from "Stores/DialerServiceStore";
import { toasterState } from "Components/common/toaster";
import countryData from "country-telephone-data";
import Flags from "Assets/png/flags.png";
import PhoneNumberDropdown from "./PhoneNumberDropdown";
import "react-telephone-input/css/default.css";

const getCountryFromPhoneNumber = phoneNumber => {
  if (!phoneNumber) return null;

  const { allCountries, allCountryCodes, iso2Lookup } = countryData;
  const cleanNumber = phoneNumber.replace(/[^\d+]/g, "");
  const inputNumberForCountries = cleanNumber.replace(/^\+/, "").substr(0, 4);

  if (allCountryCodes[inputNumberForCountries]) {
    const iso2 = allCountryCodes[inputNumberForCountries][0];
    if (iso2 && iso2Lookup[iso2] !== undefined) {
      const country = allCountries[iso2Lookup[iso2]];
      if (country) return country;
    }
  }

  let bestMatch = { dialCode: "", priority: 10001 };

  allCountries.forEach(country => {
    const numberToCheck = cleanNumber.startsWith("+")
      ? cleanNumber.replace(/^\+/, "")
      : cleanNumber;
    const dialCodeToCheck = country.dialCode.replace(/^\+/, "");

    if (numberToCheck.startsWith(dialCodeToCheck)) {
      if (
        dialCodeToCheck.length > bestMatch.dialCode.replace(/^\+/, "").length
      ) {
        bestMatch = country;
      } else if (
        dialCodeToCheck.length ===
          bestMatch.dialCode.replace(/^\+/, "").length &&
        country.priority < bestMatch.priority
      ) {
        bestMatch = country;
      }
    }
  });

  if (!bestMatch || !bestMatch.name || bestMatch.priority === 10001) {
    return null;
  }

  return bestMatch;
};

const CountryFlag = ({ country }) => {
  if (!country || !country.iso2) return null;

  return (
    <div className="react-tel-input">
      <div
        className={`flag ${country.iso2.toLowerCase()}`}
        style={{ backgroundImage: `url(${Flags})` }}
      ></div>
    </div>
  );
};

const DialerDefaultNumber = props => {
  const { calling = false } = props;
  const [loader, setLoader] = useState(true);
  const [phoneNoList, setPhoneNoList] = useState([]);
  const [defaultNo, setDefaultNo] = useState("");
  const [showDropdownMenu, setDropdownMenu] = useState(false);

  const showDropdownPhoneList = () => {
    setDropdownMenu(true);
  };

  const hideDefaultNoList = () => {
    setDropdownMenu(false);
  };

  const updateDefaultNo = (item) => {
    toasterState.setToastMsg("Please wait...", "info");
    DialerServiceData.dialerBtnLoader = true;
    DialerServiceData.updateDefaultPhoneNumber({ ph_number: item.value });
    setLoader(true);
    setDropdownMenu(false);
  };

  const getDialerDefaultNo = () => {
    if (DialerServiceData.dialerDefaultNo) {
      setDefaultNo(DialerServiceData.dialerDefaultNo);
      setLoader(false);
    }
  };

  const constructDropdownList = phoneList => {
    const newPhoneList = [];
    phoneList?.length &&
      phoneList.map((item, index) => {
        let newObj = { 
          value: item,
          key: `phoneNumber${index + 1}`,
          country: getCountryFromPhoneNumber(item)
        };
        newPhoneList.push(newObj);
      });
    setPhoneNoList(newPhoneList);
  };

  const purchaseNumberRedirect = () => {
    props.history.push("/settings/dialer/general");
  };

  useEffect(() => {
    if (
      DialerServiceData.dialerPhoneList &&
      DialerServiceData.dialerPhoneList.length > 0
    ) {
      constructDropdownList(DialerServiceData.dialerPhoneList);
    }
  }, [DialerServiceData.dialerPhoneList]);

  useEffect(() => {
    setLoader(DialerServiceData.dialerBtnLoader);
  }, [DialerServiceData.dialerBtnLoader]);

  useEffect(() => {
    getDialerDefaultNo();
  }, [DialerServiceData.dialerDefaultNo]);

  const countryInfo = getCountryFromPhoneNumber(defaultNo);

  return (
    <div className="dsDefaultNoSection">
      <div className="dsWrapDefautContact">
        {!loader && (
          <>
            {defaultNo && defaultNo !== "purchaseNumber" && (
              <div
                onClick={() => {
                  !calling && showDropdownPhoneList();
                }}
                className="numberSection"
              >
                <div className="text">Calling from: </div>
                <div className="number">
                  {countryInfo && <CountryFlag country={countryInfo} />}
                  <span className="numberText">{defaultNo}</span>
                  {!calling && (
                    <i className="material-icons">keyboard_arrow_up</i>
                  )}
                </div>
              </div>
            )}
            {defaultNo === "purchaseNumber" && (
              <>
                <div className="text">Calling from: </div>
                <div onClick={purchaseNumberRedirect} className="purchaseNumber">
                  Purchase Number
                </div>
              </>
            )}
          </>
        )}
        {loader && (
          <>
            <div className="text">Calling from: </div>
            <span className="defaultNoLoader linear-background"></span>
          </>
        )}
        {showDropdownMenu && (
          <PhoneNumberDropdown
            phoneNumbers={phoneNoList}
            selectedNumber={defaultNo}
            onSelect={updateDefaultNo}
            onClose={hideDefaultNoList}
          />
        )}
      </div>
    </div>
  );
};
export default withRouter(observer(DialerDefaultNumber));
export { DialerDefaultNumber };

